import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CatalogIndexPage, CatalogTable } from '@backstage/plugin-catalog';
import { readFilters } from './listFilters';
import { CatalogListPage } from './CatalogListPage';

/**
 * What `/catalog` shows: the catalog list, unless the address asks for a kind
 * the list does not hold.
 *
 * The list holds components and APIs (specs/catalog-list.md). Systems, groups,
 * domains, resources and templates are still reached through the catalog's
 * address — a group page's ownership card links "3 systems" to
 * `/catalog?filters[kind]=system` — so those addresses keep the stock page,
 * which lists any kind. It is rendered here rather than routed separately
 * because both answer the same path, and the question is in the query.
 */

const STOCK_COLUMNS = [
  CatalogTable.columns.createNameColumn({ defaultKind: 'Component' }),
  CatalogTable.columns.createSystemColumn(),
  CatalogTable.columns.createOwnerColumn(),
  CatalogTable.columns.createSpecTypeColumn(),
  CatalogTable.columns.createSpecLifecycleColumn(),
  CatalogTable.columns.createTagsColumn(),
];

export const CatalogIndex = () => {
  const [params] = useSearchParams();
  const { foreignKind } = useMemo(() => readFilters(params), [params]);
  return foreignKind ? (
    <CatalogIndexPage columns={STOCK_COLUMNS} />
  ) : (
    <CatalogListPage />
  );
};
